// Copyright (c) 2021 Deere & Company

import './route.scss';
import 'font-awesome/css/font-awesome.min.css';
import { BrowserRouter } from 'react-router-dom';
import IntlProvider from '../i18n-translation-config/intl-provider';
import OktaState from '../okta-state/state-connector';
import { Provider } from 'react-redux';
import React from 'react';
import { Security } from '@okta/okta-react';
import { getOktaCredentials } from '../okta-state/okta-env';
import { getStore } from '../store-reducer-config/store';
import history from '../../history';

const oktaCredentials = getOktaCredentials();

export const JDWarrantyRoutes = () => {

    const store = getStore();
    return (
        <Provider store={store}>
            <IntlProvider>
                <BrowserRouter history={history}>
                    <Security
                        client_id={oktaCredentials.clientId}
                        issuer={oktaCredentials.issuer}
                        redirect_uri={`${window.location.origin}/callback`}
                        scope={oktaCredentials.scope}
                        pkce={oktaCredentials.PKCE_AUTH_FLOW}
                    >
                        <OktaState />
                    </Security>
                </BrowserRouter>
            </IntlProvider>
        </Provider>
    );

};

export default JDWarrantyRoutes;
